/** Endpoint #26 — Feed mode page, keyset-paginated (§5.4, §12.3). */
import { z } from 'zod';
import { POSTS_SORT_KEYS } from '../columns.js';
import { SORT_DIRS } from '../enums.js';
import { MAX_FEED_LIMIT, ViewFilterParamsSchema } from './common.js';
/**
 * #26 `GET /api/views/:t/:id/feed`
 *
 * `sort`/`dir` are the #25 pair verbatim: the feed orders by every posts-table sort key, in both
 * directions, so the header Sort control means the same thing in either mode (§5.4). The cursor is
 * opaque and encodes `(sortKey, dir, sortValue, id)`; text sort values make it longer than the
 * numeric-only one it replaced.
 */
export const FeedQuerySchema = ViewFilterParamsSchema.extend({
    sort: z.enum(POSTS_SORT_KEYS).default('publishedAt'),
    dir: z.enum(SORT_DIRS).default('desc'),
    /** Opaque cursor returned as `nextCursor`; absent on the first page. */
    cursor: z.string().max(400).optional(),
    limit: z.coerce.number().int().positive().max(MAX_FEED_LIMIT).default(MAX_FEED_LIMIT),
});
//# sourceMappingURL=feed.js.map